import { render, staticRenderFns } from "./classement_collecteur.vue?vue&type=template&id=67b5e1d2&"
import script from "./classement_collecteur.vue?vue&type=script&lang=js&"
export * from "./classement_collecteur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports